<template>
  <div>
    <el-row :gutter="20">
      <el-col class="integration-settings" :span="20">
        <div>
          <div v-if="integrationWizardIndex >= 1">
            <h4 class="center-text">Kubernetes Configuration Setup</h4>
            <el-steps :active="integrationWizardIndex" :finish-status="apiCall.error? 'error': 'success'">
              <el-step></el-step>
              <el-step></el-step>
            </el-steps>
          </div>
          <el-carousel
            ref="wizard"
            :autoplay="false"
            :loop="false"
            indicator-position="none"
            arrow="never"
            height="400"
          >
            <el-carousel-item :key="1">
              <h3>How to Connect to Kubernetes</h3>
              <p>
                Confluera helps to protect your data, accounts, and workloads from unauthorized access. Confluera data
                protection servicess provide threat detection that continously monitors and protects your accounts and
                workload.
              </p>

              <el-row type="flex" :gutter="24">
                <el-col :span="4">
                  <el-card shadow="hover" style="text-align: center;">
                    <span class="display-block">
                      <h5>Kubernetes</h5>
                    </span>
                  </el-card>
                </el-col>
                <el-col :span="20">
                  <el-row> Place holder Step 1</el-row>
                  <el-row class="mt-20">Place holder Step 2 </el-row>
                  <el-row class="mt-20">Place holder Step 3 </el-row>
                </el-col>
              </el-row>
            </el-carousel-item>
            <el-carousel-item :key="2">
              <div class="box flex center ">
                <el-form :v-model="integrationWizardForm" label-width="240px" label-position="left" class="full-width">
                  <el-form-item label="Key">
                    <el-input
                      v-model="integrationWizardData.key"
                      placeholder="Enter a key for your connection"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="Nickname">
                    <el-input
                      v-model="integrationWizardData.nickName"
                      placeholder="Enter a nickname for your connection"
                      @keydown.native.space.prevent
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="Role ARN">
                    <el-input v-model="integrationWizardData.roleArn" placeholder="Enter your role ARN"></el-input>
                  </el-form-item>
                  <el-form-item label="Region">
                    <el-input v-model="integrationWizardData.region" placeholder="Enter your Region"></el-input>
                  </el-form-item>
                  <el-form-item label="Cluster Name">
                    <el-input v-model="integrationWizardData.cluster" placeholder="Enter your Cluster Name"></el-input>
                  </el-form-item>
                  <el-form-item label="Scan Frequency">
                    <el-select v-model="integrationWizardData.scanFrequency" placeholder="Select Frequency">
                      <el-option
                        v-for="item in [
                          { label: '1 Minute', value: 60000 },
                          { label: '3 Minute', value: 60000 * 3 },
                          { label: '5 Minute', value: 60000 * 5 }
                        ]"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-form>
              </div>
            </el-carousel-item>
          </el-carousel>
          <div class="flex float-right">
            <span
              v-if="integrationWizardIndex >= 1"
              class="text-underline cursor-pointer back-button"
              @click="backIntegrationStep"
            >
              Go Back
            </span>
            <el-button v-if="integrationWizardIndex < 1" size="medium" round @click="nextIntegrationStep">
              Set Up Kubernetes
            </el-button>
            <el-button v-else-if="integrationWizardIndex == 1" size="medium" round @click="updateIntegrationSettings">
              Submit
            </el-button>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { KUBERNETES_INTEGRATION_CONFIG_CREATE_REQUEST } from '@/store/modules/integrations/kubernetes-integration.type'
import integrationFormMixin from '@/components/form/integrations/integrationFormMixin'

export default {
  name: 'KubernetesIntegrationWorkflow',
  mixins: [integrationFormMixin],
  data () {
    return {
      integrationLastStep: 1
    }
  },
  methods: {
    updateIntegrationSettings () {
      this.$store.dispatch(KUBERNETES_INTEGRATION_CONFIG_CREATE_REQUEST, this.integrationWizardData).then(resp => {
        this.gotoAlertIntegrationWorkflow()
      })
    }
  },
  created () {},
  computed: {
    ...mapGetters([])
  },
  watch: {},
  components: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import 'assets/styles/_variables.css';
@import 'assets/styles/integration_workflow.css';

.verify-details-box {
  border: 2px solid black;
  border-radius: 10px;
  margin-top: 4%;
  padding: 32px;
  height: 80%;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/form/integrations/KubernetesIntegrationWorkflow.vue